var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0013 1.66675C5.4013 1.66675 1.66797 5.40008 1.66797 10.0001C1.66797 14.6001 5.4013 18.3334 10.0013 18.3334C14.6013 18.3334 18.3346 14.6001 18.3346 10.0001C18.3346 5.40008 14.6013 1.66675 10.0013 1.66675ZM10.0013 16.6667C6.31797 16.6667 3.33464 13.6834 3.33464 10.0001C3.33464 6.31675 6.31797 3.33341 10.0013 3.33341C13.6846 3.33341 16.668 6.31675 16.668 10.0001C16.668 13.6834 13.6846 16.6667 10.0013 16.6667Z",
    fill: "#969BA0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83203 11.25C6.52239 11.25 7.08203 10.6904 7.08203 10C7.08203 9.30964 6.52239 8.75 5.83203 8.75C5.14168 8.75 4.58203 9.30964 4.58203 10C4.58203 10.6904 5.14168 11.25 5.83203 11.25Z",
    fill: "#969BA0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 11.25C10.6904 11.25 11.25 10.6904 11.25 10C11.25 9.30964 10.6904 8.75 10 8.75C9.30964 8.75 8.75 9.30964 8.75 10C8.75 10.6904 9.30964 11.25 10 11.25Z",
    fill: "#969BA0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.168 11.25C14.8583 11.25 15.418 10.6904 15.418 10C15.418 9.30964 14.8583 8.75 14.168 8.75C13.4776 8.75 12.918 9.30964 12.918 10C12.918 10.6904 13.4776 11.25 14.168 11.25Z",
    fill: "#969BA0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending);
export default __webpack_public_path__ + "static/media/pending.55b4705c1beadfab94aa2a0c675ef757.svg";
export { ForwardRef as ReactComponent };